import styled from "styled-components";
import {Button, Card, Text} from "rebass";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import {minHeight, minWidth} from "styled-system";

export const StyledButton = styled(Button)`
  height: 30px;
  max-width: 29px;
  svg {
    color: white;
  }
`;

export const ForwardArrow = styled(IosArrowForward)`
	margin: 0;
	padding: 0;
	margin-top: 5px;
	margin-left: -8px;
`


export const ButtonText = styled(Text)`
	//margin-top: -9px !important;
`

export const IconText = styled(Text)`
	margin-top: -9px !important;
`

export const CardWrapper = styled(Card)`
${minWidth}
${minHeight}
  transition: all 0.5s ease;
`

export const LabelContainer = styled('div')`
	box-sizing: border-box;
	margin: 0 4px;
	padding: 8px 16px;
	background-color: #969A9B;
	color: white;
	align-items: center;
	box-shadow: 0 0 6px rgba(0,0,0,.16);
	border-radius: 50px;
	font-size: 11px;
	width: 100%;
	text-align: center;
`

export const FullWidthButton = styled(Button)`
	width: 100%;
`